import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import ExpertDataService from "../../services/Expert";
import { daysValue, generateEventsForCurrentWeek } from "../../Config/Expert";
import { useToast } from "@chakra-ui/react";
export const CreateEventModal = ({
  isOpen,
  onClose,
  func,
  timing,
  id,
  targetDay,
}: any) => {
  const toast = useToast();
  const [days, setDays] = useState<any>([]);
  const [selectedDay, setSelectedDay] = useState<string>("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const handleDays = (dayName: string) => {
    const isExist = days.find((el: string) => el === dayName);
    if (isExist) {
      const newArray = days.filter((el: string) => el !== dayName);
      setDays(newArray);
    } else {
      setDays([...days, dayName]);
    }
  };
  const clearFeild = () => {
    setDays([]);
    setEndTime("");
    setStartTime("");
  };
  const dayExist = (dayname: string) => {
    if (days && days.length > 0) {
      const isExist = days.find((el: string) => el === dayname);
      if (isExist) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const updateSchedule: any = (
    schedule: { [x: string]: any },
    days: string[],
    start: any,
    end: any
  ) => {
    for (const day of days) {
      if (day === "Monday") {
        schedule.mon.push({ start, end });
      } else if (day === "Tuesday") {
        schedule.tue.push({ start, end });
      } else if (day === "Wednesday") {
        schedule.wed.push({ start, end });
      } else if (day === "Thursday") {
        schedule.thu.push({ start, end });
      } else if (day === "Friday") {
        schedule.fri.push({ start, end });
      } else if (day === "Saturday") {
        schedule.sat.push({ start, end });
      } else if (day === "Sunday") {
        schedule.sun.push({ start, end });
      }
    }
    for (const key in schedule) {
      if ( key === "") {
        delete schedule[key];
      }
    }
    return schedule;
  };
  const handleClick = () => {
    if (startTime && endTime) {
      const schedule: any = updateSchedule(
        { ...timing },
        days,
        startTime,
        endTime
      );
      const events = generateEventsForCurrentWeek(schedule);
      clearFeild();
      ExpertDataService.postCalenderInfo(id, schedule)
        .then((res: any) => {
          func(schedule);
        })
        .catch((error: any) => {
          console.log(error);
        });
      onClose();
    } else {
      toast({
        position: "top",
        title: "Missing Feild.",
        description: "All feilds are mandatory.",
        status: "error",
        duration: 1000,
        isClosable: true,
      });
    }
  };
  const resetState = () => {
    setDays([]);
    setSelectedDay("");
    setStartTime("");
    setEndTime("");
  };
  useEffect(() => {
    if (targetDay && targetDay !== selectedDay) {
      setSelectedDay(targetDay);
      handleDays(daysValue[targetDay]);
    }
  }, [targetDay, selectedDay]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onClose();
        clearFeild();
        resetState();
      }}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Create Event</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <FormControl>
            <FormLabel>Week</FormLabel>
            <Flex>
              <span
                title="Monday"
                className={
                  dayExist("Monday")
                    ? "week_days clicked_week_days"
                    : "week_days"
                }
                onClick={() => handleDays("Monday")}
              >
                M
              </span>
              <span
                title="Tuesday"
                className={
                  dayExist("Tuesday")
                    ? "week_days clicked_week_days"
                    : "week_days"
                }
                onClick={() => handleDays("Tuesday")}
              >
                T
              </span>
              <span
                title="Wednesday"
                className={
                  dayExist("Wednesday")
                    ? "week_days clicked_week_days"
                    : "week_days"
                }
                onClick={() => handleDays("Wednesday")}
              >
                W
              </span>
              <span
                title="Thursday"
                className={
                  dayExist("Thursday")
                    ? "week_days clicked_week_days"
                    : "week_days"
                }
                onClick={() => handleDays("Thursday")}
              >
                T
              </span>
              <span
                title="Friday"
                className={
                  dayExist("Friday")
                    ? "week_days clicked_week_days"
                    : "week_days"
                }
                onClick={() => handleDays("Friday")}
              >
                F
              </span>
              <span
                title="Saturday"
                className={
                  dayExist("Saturday")
                    ? "week_days clicked_week_days"
                    : "week_days"
                }
                onClick={() => handleDays("Saturday")}
              >
                S
              </span>
              <span
                title="Sunday"
                className={
                  dayExist("Sunday")
                    ? "week_days clicked_week_days"
                    : "week_days"
                }
                onClick={() => handleDays("Sunday")}
              >
                S
              </span>
            </Flex>
          </FormControl>
          <Flex>
            <FormControl mt={4}>
              <FormLabel>Start Time </FormLabel>
              <Input
                value={startTime}
                onChange={(e) => setStartTime(e.target.value)}
                type="time"
                placeholder="Last name"
              />
            </FormControl>
            <FormControl mt={4}>
              <FormLabel>End Time</FormLabel>
              <Input
                value={endTime}
                onChange={(e) => setEndTime(e.target.value)}
                type="time"
                placeholder="Last name"
              />
            </FormControl>
          </Flex>
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={handleClick}>
            Save
          </Button>
          <Button
            onClick={() => {
              onClose();
              clearFeild();
              resetState();
            }}
          >
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
